/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SlotsInputs */

const en__field_slots = /** @type {(inputs: _Field_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time slots`)
};

const de__field_slots = /** @type {(inputs: _Field_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitslots`)
};

/**
* | output |
* | --- |
* | "Time slots" |
*
* @param {_Field_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_slots = /** @type {((inputs?: _Field_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_slots(inputs)
	return de__field_slots(inputs)
});